module.exports = __webpack_public_path__ + "img/advantage3Red.ee3acf88.png";